import React from 'react';
import _ from 'lodash';

import Dropdown from 'ub/components/dropdown/dropdown';
import fontServiceUtils from 'ub/fonts/font-service/utils';

const _googleWebFonts = fontServiceUtils.webFonts
  .map((fontName) => ({label: fontName, value: fontName}));

// need to keep a copy of the const variable so that we don't mutate on
// the original font list

// These fonts should all be stored in the font-service. Infact, most of
// this stuff should be in there.
const _familyOptions = [
  {label: "Arial", value: "Arial, sans-serif"},
  {label: "Comic Sans MS", value: 'Comic Sans MS, cursive, sans-serif'},
  {label: "Courier New", value: 'Courier New, Courier, monospace'},
  {label: "Georgia", value: "Georgia, serif"},
  {label: "Lucida Sans Unicode", value: 'Lucida Sans Unicode, Lucida Grande, sans-serif'},
  {label: "Tahoma", value: "Tahoma, Geneva, sans-serif"},
  {label: "Times New Roman", value: 'Times New Roman, Times, serif'},
  {label: "Trebuchet MS", value: 'Trebuchet MS, sans-serif'},
  {label: "Verdana", value: "Verdana, Geneva, sans-serif"}
];

let _allFonts;
let _fontNames;

function _extractBaseFamily(fullCssFamily = '') {
  const fontNames = fullCssFamily.toLowerCase().split(',');

  // if it's a single probably a non-fallback setting(google font)
  const baseName = _.isArray(fontNames) ? fontNames[0] : fontNames;
  return baseName.replace(/'|"/g, '').trim();
}

function _getSelectedFamily(familyValue) {
  const newBaseFamily = _extractBaseFamily(familyValue);

  const selectedFamilyIndex = _.findIndex(_fontNames, (fontName) =>
    fontName === newBaseFamily
  );

  if (selectedFamilyIndex >= 0) {
    return _allFonts[selectedFamilyIndex];
  } else {
    return {
      label: 'Custom',
      value: familyValue
    };
  }
}

export default class FontFamily extends React.Component {
  constructor(props) {
    super(props);

    this.changeFontFamily = this.changeFontFamily.bind(this);

    // reset to the default font list everytime we load the component
    _allFonts = _familyOptions;
    _allFonts = _allFonts.concat(_googleWebFonts);

    _fontNames = _.map(_allFonts, ({label}) =>
      label.toLowerCase());

    const selectedFamily = _getSelectedFamily(this.props.selectedFontFamily);

    this.state = {
      label: selectedFamily.label,
      value: selectedFamily.value
    };

    this.options = this.getOptionsList();
  }

  componentWillReceiveProps(nextProps) {
    const selectedFamily = _getSelectedFamily(nextProps.selectedFontFamily);
    this.setState({
      label: selectedFamily.label,
      value: selectedFamily.value
    });
  }

  componentWillUpdate() {
    this.options = this.getOptionsList();
  }

  getOptionsList() {
    return _allFonts.map(({value, label}) => {
      return {
        style: {'fontFamily': value},
        value,
        label,
        selected: value === this.state.value
      };
    });
  }

  changeFontFamily(familyValue) {
    this.props.changeHandler({
      type: 'fontFamilyChange',
      value: familyValue
    });
  }

  render() {
    return (
      <Dropdown
        className="font-family-dropdown"
        value={this.state.value}
        changeHandler={this.changeFontFamily}
        label={this.state.label}
        options={this.options}
        selectedLabelStyle={{fontFamily: this.state.value}}
      >
        {this.options}
      </Dropdown>
    );
  }
}

FontFamily.propTypes = {
  selectedFontFamily: React.PropTypes.string,
  changeHandler: React.PropTypes.func
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/font-family.jsx